import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from '../_services/alert.service';
import { environment } from '../../environments/environment';
@Injectable({
    providedIn: 'root'
})

export class DocumentoXmlService {
    public progress: number;
    public message: string;

    constructor(private http: HttpClient,
        private alertService: AlertService) { }

    ValidarDanfeSefaz(danfe: string): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/DocumentoXml/ValidarDanfeSefaz?danfe=${danfe}`;
        return this.http.get<any>(apiURL);
    }

    upload(formDataUpload: FormData): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/DocumentoXml`;

        const headers = new HttpHeaders({
            'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT'
        });

        const options = {
            headers: headers
        };

        return this.http.post<any>(apiURL, formDataUpload, options);
    }

    DownloadNFeUCM(chaveNFe: string): Observable<any> {
        const apiURL = `${environment.apiUrl}/api/DocumentoXml/DownloadNFeUCM?chaveNFe=${chaveNFe}`;
        return this.http.get<any>(apiURL);
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error); // log to console instead
            console.log(`${operation} failed: ${error.message}`);

            this.alertService.error(`Ocorreu um problema ao carregar os arquivos para o UCM: \n ${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

}
